import { Text } from '@fluentui/react';

export const RowAllocationCell = ({ projectId, allocation }: { projectId: string; allocation: number }) => {
    // Only show hours if there are any
    const hoursString = allocation > 0 ? allocation : '';

    return (
        <Text as="div" className="totalCellInner">
            {hoursString}
        </Text>
    );
};
